import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Text } from "@sitecore-jss/sitecore-jss-react";

import MediaFocal from "../../MediaFocal";
import ActionButton from "../../ActionButton";
import { BUTTONSTYLE } from "@constants";
import { useTranslation } from "react-i18next";

import { usePresentationContent } from "@store/presentation";

import "./timeline-presentation-image.scss";

const TimelinePresentationImage = ({sectionIndex, media, mediaCaption, presentationSlides, headline, isDecade}) => {
    
    const { t } = useTranslation();
  
    const texts = {
      seeAll: t(
        "FritzHansen_Project_ConsumersAndProfessionals_General_SeeAll"
      ),
    };
  
    const [image, inView] = useInView({threshold: 0.2});

    const [,setPresentationContent] = usePresentationContent();

    const openPresentationHandler = () => {
      let test = {media: media, slides: presentationSlides, headline: headline, isDecade: isDecade};
      document.body.style.overflow = 'hidden';
      setPresentationContent(test);
    };

    const getBadgeMediaFields = () => {
      let mediaFields = presentationSlides[0].fields?.media?.fields ? presentationSlides[0].fields.media.fields : null;
      if ( mediaFields ) {
        mediaFields.overlayStrength = {value: "30"};
      }
      return mediaFields;
    }

    return (
      <motion.div 
        ref={image} 
        animate={{ opacity: inView ? 1 : 0 }}
        transition={{ duration: 0.8 }}
        className={`timeline-presentation-image ${sectionIndex % 2 === 0 ? 'timeline-presentation-image--offset' : ''}`}>

        <button className="timeline-presentation-image__image" onClick={openPresentationHandler}>
          
          <p className="timeline-presentation-image__caption">
            <Text tag="span" field={mediaCaption}/>
          </p>

          {media?.fields && <MediaFocal fields={media.fields} noSave={true} />}

          {presentationSlides && presentationSlides.length ?
          <div className="timeline-presentation-image__badge">
            {getBadgeMediaFields() && <MediaFocal fields={getBadgeMediaFields()} noSave={true}/>}
            <span>{`${texts.seeAll} (${presentationSlides.length})`}</span>  
          </div> : <></>}
        </button>          

      </motion.div>
    );
};

export default TimelinePresentationImage;